export default "__VITE_ASSET__DF9jD6xc__"